import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import { restoreSession } from '@/api/auth';
import { AppLayout } from '@/components/layout/AppLayout';
import { SubjectIconProvider } from '@/components/subject-icons/SubjectIconProvider';
import { useAuthStore } from '@/stores/auth';

export const Route = createFileRoute('/_authed')({
  beforeLoad: async () => {
    // No token in memory (e.g. after a page reload) - try the refresh cookie.
    if (!useAuthStore.getState().accessToken) {
      const restored = await restoreSession();
      if (!restored) {
        throw redirect({ to: '/login' });
      }
    }
    if (useAuthStore.getState().user?.force_password_change) {
      throw redirect({ to: '/change-password' });
    }
  },
  component: () => (
    <SubjectIconProvider>
      <AppLayout>
        <Outlet />
      </AppLayout>
    </SubjectIconProvider>
  ),
});
